import {CustomerBankAccount} from "../../../../../api/customerBankAccounts/CustomerBankAccount.ts";
import {BankAccount as Relation} from "../entrepreneurSettingsPage/BankAccountsTable.tsx";

export function normalizeIban(iban: string): string {
    return iban.replace(/[\s.]+/g, '').toUpperCase();
}

export function toSelectableSavingsAccountRelations(
    relations: Array<Relation>,
    bankAccounts: Array<CustomerBankAccount>,
): Array<Relation> {
    const existingIbans = new Set(
        bankAccounts
            .map((account) => normalizeIban(account.iban ?? ''))
            .filter((iban) => iban.length > 0),
    );
    const seen = new Set<string>();
    return relations.filter((relation) => {
        const iban = normalizeIban(relation.relation_iban ?? '');
        if (!iban || existingIbans.has(iban) || seen.has(iban)) {
            return false;
        }
        seen.add(iban);
        return true;
    });
}
